export class MostSearchedTermsState {
  mostSearchedTerms: string[] = [];
}
